export const IMAGE = 'https://ukcooyocdlvo8099722.cdn.ntruss.com'
export const HOST = 'https://uihmdccdciav16245131.cdn.ntruss.com'
export const TAIL = '?type=w&w=1024&quality=80&extopt=0'
export const BLUR = '/blur.png'
